import React from "react";
import { IonPage, IonContent } from '@ionic/react';
import Header from "../components/Header";
import './PQRS.css';
import Footer from "../components/Footer";
import env from '../env.json';
import ReactGA from "react-ga4";
// import {Network} from '@awesome-cordova-plugins/network'

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/News',
//       page_title: 'News'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });

interface props {
    netState: boolean
}

// ReactGA.send({ hitType: "pageview", page: "/pages/News", title: "Tips de seguridad" });

const News: React.FC<props> = ({netState}) => {
    const urlSeguridad = 'https://mastinseguridad.com/blog/?&utm_source=app_movil&utm_medium=boton&utm_campaign=paratuseguridad';

   
    if(netState){
        return(
            <IonPage>
                <Header pageName="Para su seguridad" />
                <IonContent className="pqrs-content" id="pqrs">
                    <iframe className="pqrs-comment web-view" src={urlSeguridad} frameBorder="0"></iframe>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }
    else {
        return(
            <IonPage>
                <Header pageName="Para su seguridad" />
                <IonContent className="pqrs-content" id="pqrs">

                    <h3 className="disconnect">¡Comprueba tu conexión de internet!</h3>
                </IonContent>
                <Footer />
            </IonPage>
        );
    }

}
export default News;